import Navigator from './Navigator';
import CustomWidget from './CustomWidget'
import Interlayer from './Interlayer'
import NavigationBar from './NavigationBar'
import GraphDialog from './GraphDialog'
import Swiper from './Swiper'
import ImagesWidget from './ImagesWidget'
import ImageBar from './ImageBar'
import EmptyInterlayer from './EmptyInterlayer'
import ImageInterlayer from './ImageInterlayer'
import TimerInterlayer from './TimerInterlayer'
import CareCard from './CareCard'
import Countdown from './Countdown'
import ActivateCareDialog from './ActivateCareDialog'
import PhoneBrand from './PhoneBrand'
import ImeiDialog from './ImeiDialog'
import NormalAlert from './NormalAlert'
import YButton from './YButton'
import YApplyCardServiceDialog from './YApplyCardServiceDialog'
import YPanelMsg from './YPanelMsg'
import YActAlertDialog from './YActAlertDialog'
import YCusContentDialog from './YCusContentDialog'
export default {
    install: function (Vue) {
        Vue.component('navigator', Navigator)
        Vue.component('interlayer', Interlayer)
        Vue.component('empty-interlayer', EmptyInterlayer)
        Vue.component('image-interlayer', ImageInterlayer)
        Vue.component('timer-interlayer', TimerInterlayer)
        Vue.component('custom-widget', CustomWidget)
        Vue.component('navigation-bar', NavigationBar)
        Vue.component('graph-dialog', GraphDialog)
        Vue.component('swiper', Swiper)
        Vue.component('images-widget',ImagesWidget)
        Vue.component('image-bar',ImageBar)
        Vue.component('care-card',CareCard)
        Vue.component('countdown',Countdown)
        Vue.component('activate-care-dialog',ActivateCareDialog)
        Vue.component('phone-brand-dialog',PhoneBrand) 
        Vue.component('imei-dialog',ImeiDialog) 
        Vue.component('normal-alert',NormalAlert)
        Vue.component('y-button',YButton)
        Vue.component('y-apply-card-service',YApplyCardServiceDialog)
        Vue.component('y-panel-msg',YPanelMsg)
        Vue.component('y-act-alert-dialog',YActAlertDialog)
        Vue.component('y-cus-content-dialog',YCusContentDialog)
    }
}
